import { supabase } from './supabase'

export interface SignUpData {
  email: string
  password: string
  role: 'customer' | 'technician'
  fullName: string
  phone: string
}

export const signUpUser = async (email: string, password: string, role: 'customer' | 'technician', fullName: string, phone: string) => {
  try {
    // Sign up the user with Supabase Auth
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email,
      password,
    })

    if (authError) throw authError

    const user = authData.user
    if (!user) throw new Error('User not created')

    // Create user profile in the profiles table
    const { error: profileError } = await supabase.from('profiles').insert([
      {
        id: user.id,       // ✅ MUST match auth.uid()
        role,
        full_name: fullName,
        phone_number: phone,
        email,
      },
    ])

    if (profileError) {
      console.error('Profile insert error:', profileError)
    }
    
    // if (profileError) {
    //   throw new Error(`Failed to create profile: ${profileError.message}`)
    // }

    return { user, session: authData.session }
  } catch (error: any) {
    throw new Error(error.message || 'Failed to sign up')
  }
}

export const signInUser = async (email: string, password: string) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })

    if (error) {
      throw new Error(error.message)
    }

    return data
  } catch (error: any) {
    throw new Error(error.message || 'Failed to sign in')
  }
}

export const signOutUser = async () => {
  try {
    const { error } = await supabase.auth.signOut()
    if (error) {
      throw new Error(error.message)
    }
  } catch (error: any) {
    throw new Error(error.message || 'Failed to sign out')
  }
}

export const getCurrentUser = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser()
    if (error) {
      throw new Error(error.message)
    }
    return user
  } catch (error: any) {
    throw new Error(error.message || 'Failed to get current user')
  }
}
